import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const GMTClock = () => {
  const [time, setTime] = useState(dayjs().utc().add(8, 'hour')); // PHT = UTC+8

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(dayjs().utc().add(8, 'hour'));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        fontSize: '0.9rem',
        whiteSpace: 'nowrap',
        color: '#0f0e0eff', // ← add this
        fontWeight: 'bold' // optional for visibility
      }}
    >
      GMT {time.format('hh:mm:ss A DD MMM YYYY')}
    </div>
  );

};

export default GMTClock;
